import { isValidJSON } from "./helpers"


interface iSort {id: number, view_name:string, view_field:string}
type listsort =(number | undefined) []
export function getSort (category:string,field_name:string):number|undefined {
    let sort_list = isValidJSON(localStorage.getItem("sort") || "") ? 
    JSON.parse(localStorage.getItem("sort") || "") : null

    if(!sort_list)
        return undefined
    let sort_item:iSort|undefined  = sort_list.sort.filter(
        (ele:iSort)=>ele.view_name ===category && ele.view_field===field_name)[0]
   
    if (sort_item) {

        return sort_item.id
    }
    return undefined
}

export function getListSort (fields:string[], category :string): listsort {
    let sort_fields:listsort=[]
    fields.forEach(element => {
      let field_id=  getSort(category,element)
      sort_fields.push(field_id)
    });
   
    return sort_fields
}